import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failures = [{
  title: 'Dietas de 30 días',
  desc: 'Son imposibles de seguir cuando necesitas verte bien para un evento mañana mismo.'
}, {
  title: 'Jugos verdes',
  desc: 'Están llenos de oxalatos e irritantes que inflaman las paredes de tu intestino.'
}, {
  title: "Laxantes 'naturales'",
  desc: 'Deshidratan tus células y provocan un efecto rebote de hinchazón peor al día siguiente.'
}, {
  title: 'Ejercicio intenso',
  desc: 'Eleva el cortisol, enviando la señal a tu cuerpo de retener todavía más líquido en el área abdominal.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FailedSolutions() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-19">
            Por qué lo que has intentado no funciona
          </h2>
          <div className="w-24 h-1 bg-orange mx-auto rounded-full" data-id="element-20"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid sm:grid-cols-2 gap-6" data-id="element-21">
          {failures.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-cream p-6 rounded-2xl border border-cream-dark shadow-sm hover:shadow-md transition-shadow" data-id="element-22">
              <div className="flex items-start gap-4" data-id="element-23">
                <XCircle className="w-6 h-6 text-orange shrink-0 mt-1" data-id="element-24" />
                <div data-id="element-25">
                  <h3 className="font-bold text-lg text-charcoal mb-2" data-id="element-26">
                    {item.title}
                  </h3>
                  <p className="text-charcoal-light leading-relaxed" data-id="element-27">
                    {item.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}